import { FontWeightType } from 'components/VisualStudioPlayground/VisualEditor/Types'
import FontFaceObserver from 'fontfaceobserver'
import { makeAutoObservable } from 'mobx'
import { Font } from 'types'
import { reportError } from 'utils/error'
import { IFont, LoadingState } from 'stores/IFont'

export type ICustomFont = Font

const FONT_LOADING_TIMEOUT = 30000 // 30s

// Workspace fonts are single-face: each row is its own .ttf, registered as @font-face
// at weight 400. The backend rejects text styles that pair a workspace font with any
// other weight, so we only ever expose 400.
const CUSTOM_FONT_WEIGHTS: FontWeightType[] = [400]

export class CustomFont implements IFont {
  name: IFont['name']
  family: IFont['family']
  sourceUrl: string
  variants: IFont['variants'] = ['Regular']
  workspaceId: number
  loadingState: IFont['loadingState'] = 'idle'
  loadingPromise?: IFont['loadingPromise']

  constructor(font: ICustomFont, workspaceId: number) {
    makeAutoObservable(this)

    this.name = font.name
    this.family = font.font_family
    this.sourceUrl = font.source_url
    this.workspaceId = workspaceId
  }

  get weights() {
    return CUSTOM_FONT_WEIGHTS
  }

  get italicWeights() {
    return CUSTOM_FONT_WEIGHTS
  }

  get url() {
    return this.sourceUrl
  }

  setLoadingState = (loadingState: LoadingState) => {
    this.loadingState = loadingState
  }

  load = async () => {
    if (this.loadingState === 'loaded' || this.loadingState === 'loading') {
      return this.loadingPromise
    }

    this.setLoadingState('loading')
    this.loadingPromise = new FontFaceObserver(this.name, { weight: '400' })
      .load(null, FONT_LOADING_TIMEOUT)
      .then(() => {
        this.setLoadingState('loaded')
      })
      .catch((e) => {
        reportError(e)
        this.setLoadingState('idle')
      })

    return this.loadingPromise
  }
}
